import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import FeaturedImage from "@stjudecloud/assets/images/featured-study.jpg";
import GenomicsPlatformIcon from "@stjudecloud/assets/images/icon-genomics-platform.png";
import ModelSystemsIcon from "@stjudecloud/assets/images/icon-model-systems.png";
import PeCanIcon from "@stjudecloud/assets/images/icon-pecan.png";
import VizCommIcon from "@stjudecloud/assets/images/icon-viz.png";

function MegaMenu() {
  return /*#__PURE__*/React.createElement(Container, {
    className: "mega-menu-container"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 3,
      order: 2
    },
    className: "mega-dropdown-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mega-menu-title"
  }, "Research Domains"), /*#__PURE__*/React.createElement("ul", {
    className: "list-unstyled"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://stjude.cloud/research-domains/pediatric-cancer"
  }, "Pediatric Cancer")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://stjude.cloud/research-domains/cancer-survivorship"
  }, "Cancer Survivorship")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://stjude.cloud/research-domains/non-cancerous-diseases"
  }, "Non-cancerous Diseases")))), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 3,
      order: 3
    },
    className: "mega-dropdown-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mega-menu-title"
  }, "Apps"), /*#__PURE__*/React.createElement("ul", {
    className: "list-unstyled"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://platform.stjude.cloud",
    className: "app-title"
  }, /*#__PURE__*/React.createElement("img", {
    className: "app-title__icon",
    src: GenomicsPlatformIcon,
    alt: "Genomics Platform Icon"
  }), /*#__PURE__*/React.createElement("span", null, "Genomics Platform", /*#__PURE__*/React.createElement("div", {
    className: "genomics-platform-subtext"
  }, "Data & Tools")))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://models.stjude.cloud/",
    className: "app-title"
  }, /*#__PURE__*/React.createElement("img", {
    className: "app-title__icon",
    src: ModelSystemsIcon,
    alt: "Model Systems Icon"
  }), /*#__PURE__*/React.createElement("span", null, "Model Systems"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://pecan.stjude.cloud/",
    className: "app-title"
  }, /*#__PURE__*/React.createElement("img", {
    className: "app-title__icon",
    src: PeCanIcon,
    alt: "PeCan Icon"
  }), /*#__PURE__*/React.createElement("span", null, "PeCan"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://viz.stjude.cloud",
    className: "app-title"
  }, /*#__PURE__*/React.createElement("img", {
    className: "app-title__icon",
    src: VizCommIcon,
    alt: "Visualization Community Icon"
  }), /*#__PURE__*/React.createElement("span", null, "Visualization Community"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://stjude.cloud/apps",
    className: "text-primary"
  }, "View All Apps")))), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 3,
      order: 1
    },
    className: "mega-dropdown-col d-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "featured-study"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://stjude.cloud/studies/clinical-genomics"
  }, /*#__PURE__*/React.createElement("img", {
    className: "featured-study__image",
    src: FeaturedImage,
    alt: "Featured Study Image"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "featured-study__title"
  }, "Featured Study"), /*#__PURE__*/React.createElement("ul", {
    className: "list-unstyled"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://stjude.cloud/studies/clinical-genomics"
  }, "Real-time Clinical Genomics")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://stjude.cloud/studies",
    className: "text-primary"
  }, "View All Studies")))))), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 3,
      order: 4
    },
    className: "mega-dropdown-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mega-menu-title"
  }, "Support"), /*#__PURE__*/React.createElement("ul", {
    className: "list-unstyled"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://university.stjude.cloud/docs/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Help Guides")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://university.stjude.cloud/docs/faq/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "FAQs"))))));
}

MegaMenu.displayName = "St. Jude Cloud Navbar MegaMenu";
export default MegaMenu;